export default __webpack_public_path__ + "static/social-02deaa213ecda1e24b2a4f6f01d0881a.png";